<template>
    <div v-if="isNew">
        <div class="badge lead-target-bg" @click="goToLead">
            Целевой
        </div>
        <div class="badge lead-not-target-bg ml10" @click="goToLead">
            Не целевой
        </div>
    </div>
</template>

<script>
import localReferences from '@/helpers/localReferences';
import Vue from 'vue';

export default Vue.extend({
    data: function() {
        return {
            visible: false,
            leadId: null,
            status_id: null
        };
    },
    beforeMount() {
    },
    mounted() {
        this.status_id = this.params.data.status_id;
        this.leadId = this.params.data.id;
    },
    computed: {
        isNew() {
            return this.status_id === localReferences.leadStatuses.statusNew;
        }
    },
    methods: {
        goToLead() {
            this.$router.push({ name: 'lead-card', params: { id: '' + this.leadId } });
        }
    }
});
</script>
